export type FunnelStage = { label: string; value: number };

// Passos do degradê sequencial azul (skill de dataviz), ≥ step 250 — piso de
// contraste 2:1 exigido pra uso ordinal (estágios discretos, não magnitude contínua).
const FUNNEL_COLORS = ["#86b6ef", "#3987e5", "#1c5cab", "#0d366b"];

type Props = {
  data: FunnelStage[];
};

const ConversionFunnel = ({ data }: Props) => {
  const max = data[0]?.value || 0;

  return (
    <div className="flex flex-col gap-3">
      {data.map((stage, i) => {
        const widthPct = max > 0 ? Math.max(8, (stage.value / max) * 100) : 0;
        const prevValue = i > 0 ? data[i - 1].value : null;
        const conversion = prevValue ? Math.round((stage.value / prevValue) * 1000) / 10 : null;

        return (
          <div key={stage.label} className="flex items-center gap-3">
            <div className="w-36 shrink-0 text-sm text-slate-600">{stage.label}</div>
            <div className="flex-1 flex items-center gap-2">
              <div
                className="h-8 rounded-md flex items-center justify-end px-2.5 transition-[width] duration-300"
                style={{ width: `${widthPct}%`, background: FUNNEL_COLORS[i % FUNNEL_COLORS.length] }}
              >
                <span className="text-xs font-semibold text-white tabular-nums">{stage.value}</span>
              </div>
              {conversion != null && (
                <span className="text-xs text-slate-400 whitespace-nowrap">{conversion}% do anterior</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ConversionFunnel;
